module.exports = __webpack_public_path__ + "img/walk-gray.ec5b9795.svg";